import { render, staticRenderFns } from "./RecentEntries.vue?vue&type=template&id=e261b40a"
import script from "./RecentEntries.vue?vue&type=script&lang=ts"
export * from "./RecentEntries.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports